export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="14" y="14" width="36" height="36" transform="rotate(45 32 32)" fill="none" stroke="var(--gold)" strokeWidth="2.5" />
    <text x="32" y="40" textAnchor="middle" fontFamily="Fraunces, Georgia, serif" fontSize="22" fontStyle="italic" fill="currentColor">S</text>
  </svg>
);

export const Logo = ({ onClick }) => (
  <button onClick={onClick} data-testid="header-logo" className="flex items-center gap-3 text-[var(--ivory)]">
    <LogoMark />
    <span className="text-left leading-none">
      <span className="block font-display text-lg tracking-tight">S&amp;LC</span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--muted-dark)]">Personnel Mgmt</span>
    </span>
  </button>
);
